/**
 * MicroStrategy is being retired. A level 5 super admin turns it off for the
 * whole environment with the "Disable MicroStrategy" admin action, which sets
 * this system config. The status is loaded at sign in, so other users see the
 * change the next time they load the app. Until then MicroStrategy stays
 * enabled, including when the status cannot be loaded.
 *
 * Kept free of imports: it is read by components that must not pull in the
 * API client.
 */
export const MSTR_DISABLED_SYS_CONFIG = "mstrDisabled";

let disabled = false;

export function isMicroStrategyDisabled() {
    return disabled;
}

export function setMicroStrategyDisabled(value) {
    disabled = value === true || value === "true";
}

/**
 * @param {function(): Promise<{disabled: boolean}>} getStatus
 */
export async function loadMicroStrategyStatus(getStatus) {
    try {
        const status = await getStatus();
        setMicroStrategyDisabled(status && status.disabled);
    } catch (err) {
        console.error(`Unable to load the MicroStrategy status: ${err}`);
    }
}
